"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseHistoryBox = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../atome");
const CaseHistoryBox_style_1 = require("./CaseHistoryBox.style");
function CaseHistoryBox({ progress = 0, label = '', buttonText, onPress, }) {
    return (react_1.default.createElement(react_native_1.View, { style: CaseHistoryBox_style_1.styles.container },
        react_1.default.createElement(react_native_1.View, { style: [CaseHistoryBox_style_1.styles.box, CaseHistoryBox_style_1.styles.shadow] },
            react_1.default.createElement(react_native_1.View, { style: [CaseHistoryBox_style_1.styles.textContainer] },
                react_1.default.createElement(atome_1.Text, { style: [CaseHistoryBox_style_1.styles.text] }, label)),
            react_1.default.createElement(react_native_1.View, { style: CaseHistoryBox_style_1.styles.progressContainer },
                react_1.default.createElement(react_native_1.View, { style: [CaseHistoryBox_style_1.styles.progress, { width: progress + '%' }] })),
            react_1.default.createElement(react_native_1.View, { style: CaseHistoryBox_style_1.styles.buttonContainer },
                react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.75, style: [CaseHistoryBox_style_1.styles.button], onPress: () => onPress() },
                    react_1.default.createElement(atome_1.Text, { style: [CaseHistoryBox_style_1.styles.buttonText] }, buttonText))))));
}
exports.CaseHistoryBox = CaseHistoryBox;
